/*
 * Copyright © 2022 EPO: European Patent Office.
 * ALL RIGHTS RESERVED
 */

import React from 'react';

import { useTranslation } from 'react-i18next';
import { Dialog, Typography, Table, TableBody, TableCell, TableHead, TableRow } from '@material-ui/core';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogContent from '@material-ui/core/DialogContent';
import DialogActions from '@material-ui/core/DialogActions';
import Button from './Button';
import { EntityType } from '../../shared/submission/usePartiesService';

export default function ConfirmDelete({ selection, deleteDialog }) {
  const { t } = useTranslation();
  const { values: contacts } = deleteDialog;

  const partyDetailsMap = {
    [EntityType.NATURAL_PERSON]: {
      label: t('parties.natural-person'),
      nameFunction: contact => `${contact.firstName} ${contact.lastName}`,
      residenceFunction: contact => contact.country,
    },
    [EntityType.LEGAL_ENTITY]: {
      label: t('parties.legal-entity'),
      nameFunction: contact => `${contact.company}`,
      residenceFunction: contact => contact.placeOfBusiness,
    },
  };

  return (
    <Dialog open={deleteDialog.isOpen} fullWidth maxWidth="md">
      <DialogTitle>
        <Typography component="h2" variant="h2">
          {t('messages.are-you-sure')}
        </Typography>
      </DialogTitle>
      <DialogContent>
        {t('contact.delete.confirmation', { amount: selection.length })}
        <Table>
          <TableHead>
            <TableRow>
              <TableCell align="left">{t('Type')}</TableCell>
              <TableCell align="left">{t('name.company')}</TableCell>
              <TableCell align="left">{t('country.place-of-business')}</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {contacts?.map((contact) => {
              const partyDetails = partyDetailsMap[contact.partyType];
              return (
                <TableRow key={contact?.id} id={contact?.id}>
                  <TableCell align="left">{partyDetails?.label}</TableCell>
                  <TableCell align="left">{partyDetails?.nameFunction(contact)}</TableCell>
                  <TableCell align="left">{partyDetails?.residenceFunction(contact)}</TableCell>
                </TableRow>
              );
            })}
          </TableBody>
        </Table>
      </DialogContent>
      <DialogActions>
        <Button id="cancelDelete" color="default" onClick={deleteDialog.close}>
          {t('actions.cancel')}
        </Button>
        <Button id="delete" color="primary" onClick={deleteDialog.confirm(deleteDialog.values)}>
          {t('actions.delete')}
        </Button>
      </DialogActions>
    </Dialog>
  );
}
